import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const SecondaryHeader = ({ className, children }) => (
  <div className={classnames('c-header-secondary-wrapper', className)}>
    <div className="c-header-secondary">
      { children }
    </div>
  </div>
);
SecondaryHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
SecondaryHeader.defaultProps = {
  className: '',
};

export default SecondaryHeader;
